const shaderType = {
  contour: 'useContour',
  heightMap: 'useHeightMap',
  slopeMap: 'useSlopeMap'
};

export default shaderType;
